var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.hasContent
        ? _c("div", { staticClass: "content" }, [_vm._t("default")], 2)
        : _vm._e(),
      _vm.errorMessage
        ? _c("b-notification", { attrs: { type: "is-danger" } }, [
            _c("span", { domProps: { innerHTML: _vm._s(_vm.errorMessage) } }),
          ])
        : _vm._e(),
      _c(
        "draggable",
        {
          attrs: {
            list: _vm.myValue,
            group: { draggable: ".listing-brochure" },
          },
          on: { end: _vm.end },
        },
        [
          _vm._l(_vm.myFields, function (_name, index) {
            return _c("form-file", {
              key: index,
              staticClass: "listing-brochure",
              attrs: {
                name: _name,
                "on-delete": function () {
                  return _vm.deleteFile(index)
                },
              },
            })
          }),
          _vm.progress
            ? _c(
                "progress",
                {
                  staticClass: "progress is-primary",
                  attrs: { max: "100" },
                  domProps: { value: _vm.progress },
                },
                [_vm._v(" " + _vm._s(_vm.progress) + "% ")]
              )
            : _vm._e(),
          _c("dropzone", {
            class: { "is-active": _vm.myFields.length },
            attrs: { id: _vm.name, options: _vm.options },
            on: {
              "vdropzone-error": _vm.uploadError,
              "vdropzone-error-multiple": _vm.uploadError,
              "vdropzone-success": _vm.success,
              "vdropzone-total-upload-progress": _vm.upload,
              "vdropzone-queue-complete": _vm.complete,
            },
          }),
          _vm.showError
            ? _c("p", { staticClass: "help is-danger" }, [
                _vm._v(_vm._s(_vm.error)),
              ])
            : _vm._e(),
        ],
        2
      ),
      _c("div", { staticClass: "my-preview" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }